import React from 'react';
import { Outlet, useNavigate, useLocation, useOutletContext } from 'react-router-dom';
import { Container, Row, Col, Nav } from 'react-bootstrap';

export function ReportsLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useOutletContext();

  const getActiveKey = () => {
    const path = location.pathname;
    if (path.includes('/reports/asset')) return 'asset';
    if (path.includes('/reports/revenue')) return 'revenue';
    return 'monthly-analysis';
  };

  return (
    <Container fluid className="py-4">
      <Row className="mb-3">
        <Col>
          <h2>Reports</h2>
        </Col>
      </Row>
      <Row>
        <Col md={3} className="mb-3">
          <Nav variant="pills" className="flex-column flex-md-column flex-row flex-wrap">
            <Nav.Item>
              <Nav.Link
                active={getActiveKey() === 'monthly-analysis'}
                onClick={() => navigate('/dashboard/reports/monthly-analysis')}
              >
                Monthly Analysis
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                active={getActiveKey() === 'asset'}
                onClick={() => navigate('/dashboard/reports/asset')}
              >
                Asset
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                active={getActiveKey() === 'revenue'}
                onClick={() => navigate('/dashboard/reports/revenue')}
              >
                Location Revenue
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col md={9}>
          <Outlet context={context} />
        </Col>
      </Row>
    </Container>
  );
}

export default ReportsLayout;
